import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickActionTile = ({ 
  title = '', 
  description = '', 
  icon = 'Activity', 
  path = '/',
  color = 'primary'
}) => {
  const navigate = useNavigate();

  const colorStyles = {
    primary: {
      bg: 'bg-primary/10',
      hover: 'hover:bg-primary/20',
      icon: 'var(--color-primary)',
      text: 'text-primary'
    },
    secondary: {
      bg: 'bg-secondary/10',
      hover: 'hover:bg-secondary/20',
      icon: 'var(--color-secondary)',
      text: 'text-secondary'
    },
    accent: {
      bg: 'bg-accent/10',
      hover: 'hover:bg-accent/20',
      icon: 'var(--color-accent)',
      text: 'text-accent'
    }
  };

  const styles = colorStyles?.[color] || colorStyles?.primary;

  return (
    <button
      onClick={() => navigate(path)}
      className={`w-full text-left bg-card border border-border rounded-lg p-4 md:p-6 elevation-sm hover:elevation-md transition-smooth ${styles?.hover}`}
    >
      <div className="flex items-start gap-4">
        <div className={`w-12 h-12 md:w-14 md:h-14 rounded-lg ${styles?.bg} flex items-center justify-center flex-shrink-0`}>
          <Icon name={icon} size={24} color={styles?.icon} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className={`text-base md:text-lg font-semibold font-heading mb-2 ${styles?.text}`}>
            {title}
          </h4>
          <p className="text-sm text-muted-foreground font-body line-clamp-2">
            {description}
          </p>
          <div className="flex items-center gap-2 mt-3">
            <span className="text-xs font-medium font-caption text-foreground">
              Open Tool
            </span>
            <Icon name="ArrowRight" size={14} color="var(--color-foreground)" />
          </div>
        </div>
      </div>
    </button>
  );
};

export default QuickActionTile;